import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, TemplateRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, combineLatest, map, Observable } from 'rxjs';

interface TemplateInterface {
  template: BehaviorSubject<TemplateRef<any> | null>;
  breakPoints?: string[];
}

@Injectable({ providedIn: 'root' })
export class HeaderTemplateService {
  private templateSubjects: Record<string, TemplateInterface> = {
    startHeader: {
      template: new BehaviorSubject<TemplateRef<any> | null>(null),
      breakPoints: [],
    },
    itemHeader: {
      template: new BehaviorSubject<TemplateRef<any> | null>(null),
      breakPoints: [],
    },
    endHeader: {
      template: new BehaviorSubject<TemplateRef<any> | null>(null),
      breakPoints: [],
    },
    buttonNavigateHeader: {
      template: new BehaviorSubject<TemplateRef<any> | null>(null),
      breakPoints: [],
    },
  };

  constructor(
    private router: Router,
    private breakPointObserver: BreakpointObserver,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        Object.values(this.templateSubjects).forEach((subject) => {
          subject.template.next(null);
        });
      }
    });
  }

  // check memory lick
  setHeaderTemplate(
    headerKey: keyof typeof this.templateSubjects,
    value: { template: TemplateRef<any>; breakPoints?: string[] },
  ): void {
    const headerSubject = this.templateSubjects[headerKey];
    if (value.breakPoints?.length) {
      this.breakPointObserver
        .observe(value.breakPoints)
        .pipe(map((result) => (result.matches ? value.template : null)))
        .subscribe(headerSubject.template);
    } else {
      headerSubject.template.next(value.template);
    }
  }

  get allTemplates$(): Observable<Record<string, TemplateRef<any> | null>> {
    return combineLatest(
      Object.entries(this.templateSubjects).map(([key, subject]) =>
        subject.template.pipe(map((template) => ({ [key]: template }))),
      ),
    ).pipe(map((results) => Object.assign({}, ...results)));
  }
}
